import React from "react";
import { GlobeIcon, LockIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
type OfferBoxProps = {
  ctaLabel: string;
  ctaNote: string;
};
export function OfferBox({
  ctaLabel,
  ctaNote
}: OfferBoxProps) {
  return <div className="mx-auto w-full max-w-xl rounded-3xl bg-white p-5 text-center text-ink ring-4 ring-gold sm:p-8" data-id="element-41" data-mp="1op73sv2bndxj">
      <p className="text-base font-bold uppercase tracking-wide text-ink-muted" data-id="element-42" data-mp="2ce9rajjn00zy">
        Total suggested value: <span className="text-alert line-through" data-id="element-43" data-mp="2hc1i1a8jph2k">$180</span>
      </p>
      <p className="mt-4 text-sm font-extrabold uppercase tracking-[0.14em] text-brand" data-id="element-44" data-mp="23kd91ftlf8pt">
        Your price today
      </p>
      <p className="font-display text-8xl font-extrabold leading-none text-ink" data-id="element-45" data-mp="27lgk7p0p4gkp">
        $27<span className="ml-1 text-3xl" data-id="element-46" data-mp="2vbstb37ogjcv">USD</span>
      </p>
      <p className="mt-1 text-sm font-semibold text-success" data-id="element-47" data-mp="3032gzy9o1cm4">You save $153 · One-time payment</p>

      <div className="mt-4 flex items-start gap-2.5 rounded-xl bg-brand-soft px-4 py-3 text-left" data-id="element-48" data-mp="35g4hl4h7vatj">
        <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-49" data-mp="30hkw156jc11p" />
        <p className="text-sm font-medium leading-snug text-ink" data-id="element-50" data-mp="3f677gvt1k8nn">
          <strong data-id="element-51" data-mp="3f7ibmwqefifa">Automatic currency conversion:</strong> the price is converted to your local
          currency at checkout.
        </p>
      </div>

      <div className="mt-6" data-id="element-52" data-mp="3o6cgfadvvf3x">
        <CTAButton label={ctaLabel} note={ctaNote} data-id="element-53" data-mp="3o5kk1xcgpdcl" />
      </div>

      <div className="mt-6 space-y-5" data-id="element-54" data-mp="3k5k3o75sys2w">
        <Countdown data-id="element-55" data-mp="3k4il7hmgj3b5" />
        <ScarcityBar data-id="element-56" data-mp="3k7d2j0a6c80c" />
      </div>

      <p className="mt-5 flex items-center justify-center gap-1.5 text-sm font-semibold text-ink-muted" data-id="element-57" data-mp="1zf8baq91n06">
        <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-58" data-mp="3t5gpm10t5cu9" />
        Secure checkout · One-time payment
      </p>
    </div>;
}